var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUniCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2516_326)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.431 286.963H272.086C260.659 286.963 249.7 291.502 241.62 299.583C233.539 307.663 229 318.622 229 330.049V646.014C229 657.441 233.539 668.401 241.62 676.481C249.7 684.561 260.659 689.1 272.086 689.1H702.948C714.375 689.1 725.334 684.561 733.414 676.481C741.495 668.401 746.034 657.441 746.034 646.014V502.394M487.517 689.1V803.997",
    stroke: "#744610",
    strokeWidth: 34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.895 803.996H631.136",
    stroke: "#744610",
    strokeWidth: 34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.768 287.41C769.526 286.187 769.024 285.029 768.296 284.017C767.568 283.005 766.63 282.162 765.548 281.544L733.19 263.078L733.06 226.558C733.056 225.3 732.779 224.058 732.249 222.918C731.719 221.778 730.948 220.766 729.99 219.953C718.252 210.011 704.735 202.391 690.158 197.5C689.01 197.111 687.793 196.967 686.586 197.078C685.379 197.188 684.209 197.55 683.15 198.141L650.51 216.412L617.838 198.109C616.778 197.514 615.606 197.149 614.398 197.037C613.189 196.925 611.97 197.068 610.819 197.457C596.251 202.379 582.748 210.028 571.031 219.997C570.074 220.808 569.304 221.818 568.774 222.956C568.244 224.095 567.966 225.335 567.961 226.59L567.798 263.143L535.44 281.61C534.358 282.227 533.42 283.07 532.692 284.082C531.964 285.094 531.462 286.252 531.22 287.475C528.26 302.378 528.26 317.718 531.22 332.621C531.462 333.844 531.964 335.002 532.692 336.014C533.42 337.026 534.358 337.869 535.44 338.486L567.798 356.953L567.928 393.484C567.932 394.742 568.209 395.983 568.739 397.124C569.269 398.264 570.04 399.275 570.998 400.088C582.736 410.031 596.253 417.65 610.83 422.541C611.978 422.93 613.195 423.074 614.402 422.964C615.609 422.854 616.779 422.491 617.838 421.9L650.51 403.575L683.183 421.879C684.476 422.601 685.933 422.975 687.413 422.965C688.361 422.964 689.303 422.81 690.201 422.509C704.766 417.588 718.267 409.947 729.99 399.99C730.947 399.179 731.717 398.169 732.247 397.031C732.777 395.893 733.054 394.653 733.06 393.397L733.222 356.844L765.58 338.378C766.663 337.761 767.6 336.917 768.328 335.905C769.056 334.893 769.558 333.736 769.8 332.512C772.744 317.621 772.733 302.296 769.768 287.41ZM650.51 353.444C641.929 353.444 633.54 350.896 626.404 346.121C619.269 341.347 613.707 334.561 610.423 326.621C607.139 318.682 606.28 309.945 607.954 301.517C609.628 293.088 613.761 285.346 619.829 279.27C625.897 273.193 633.628 269.055 642.045 267.378C650.462 265.702 659.186 266.562 667.115 269.851C675.043 273.139 681.82 278.708 686.588 285.854C691.355 292.999 693.9 301.4 693.9 309.994C693.9 321.517 689.329 332.569 681.192 340.718C673.054 348.866 662.018 353.444 650.51 353.444Z",
    fill: "#368D01"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint0_linear_2516_326)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint1_linear_2516_326)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2516_326",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2516_326",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2516_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUniCare);
export default __webpack_public_path__ + "static/media/Logo_UniCare.f25be3895bafc612a5a8d683820599c0.svg";
export { ForwardRef as ReactComponent };